// templates/InlineTemplate.ts
import { BaseTemplate } from "./BaseTemplate";
export class InlineTemplate extends BaseTemplate {
    constructor(action) {
        super(action);
        this.originalHeight = 0;
    }
    render() {
        var _a, _b, _c, _d;
        const selector = (_b = (_a = this.action) === null || _a === void 0 ? void 0 : _a.showWhat) === null || _b === void 0 ? void 0 : _b.Selector;
        const position = ((_d = (_c = this.action) === null || _c === void 0 ? void 0 : _c.showWhat) === null || _d === void 0 ? void 0 : _d.Position) || "after";
        if (!selector) {
            console.warn("InlineTemplate: No selector provided.");
            return;
        }
        const target = document.querySelector(selector);
        if (!target) {
            console.warn(`InlineTemplate: Target element not found: ${selector}`);
            return;
        }
        // Save original height
        this.originalHeight = target.offsetHeight;
        // Set HTML
        this.container.innerHTML = this.getProcessedHtml();
        this.executeScripts(this.container);
        // Insert based on position
        switch (position) {
            case "before":
                target.insertAdjacentElement("beforebegin", this.container);
                break;
            case "after":
                target.insertAdjacentElement("afterend", this.container);
                break;
            case "withinBottom":
                this.insertWithinContent(target);
                break;
            default:
                target.insertAdjacentElement("afterend", this.container);
        }
        this.applyTransitionIn();
        this.setupCloseHandler();
    }
    insertWithinContent(target) {
        var _a, _b, _c;
        const paragraphFromBottom = Number(((_b = (_a = this.action) === null || _a === void 0 ? void 0 : _a.showWhat) === null || _b === void 0 ? void 0 : _b.InlineParagraph) || 0);
        // Insert as first child if 0
        if (paragraphFromBottom === 0) {
            target.insertAdjacentElement("afterbegin", this.container);
            return;
        }
        const paragraphs = target.querySelectorAll(":scope > p");
        // No paragraphs → insert after container
        if (!paragraphs || paragraphs.length === 0) {
            target.insertAdjacentElement("afterend", this.container);
            return;
        }
        // Not enough paragraphs → insert before container
        if (paragraphs.length < paragraphFromBottom) {
            target.insertAdjacentElement("beforebegin", this.container);
            return;
        }
        // Valid case → insert before correct paragraph
        const indexFromTop = paragraphs.length - paragraphFromBottom;
        const paragraph = paragraphs[indexFromTop];
        (_c = paragraph.parentElement) === null || _c === void 0 ? void 0 : _c.insertBefore(this.container, paragraph);
    }
    incrementSelectorHeight() {
        var _a, _b;
        const selector = (_b = (_a = this.action) === null || _a === void 0 ? void 0 : _a.showWhat) === null || _b === void 0 ? void 0 : _b.Selector;
        const target = document.querySelector(selector);
        if (!target)
            return;
        const templateHeight = this.container.offsetHeight;
        target.style.height =
            this.originalHeight + templateHeight + "px";
    }
}
